import {snakeToCapital} from 'util/NameUtil';

export const SYSTEM_COLUMN_NAMES = ['_pkey', '_sync_key'];

/**
 * Return a human readable warehouse column name by removing trailing $, and converting to capitalized words.
 *
 * E.g. 'sql_identifier$' -> 'Sql identifier'
 *
 * Returns null for system columns
 */
export function columnNameToDisplayName(columnName: string): string | null {
  if (SYSTEM_COLUMN_NAMES.includes(columnName)) {
    return null;
  }

  if (columnName.endsWith('$')) {
    columnName = columnName.slice(0, -1);
  }
  return snakeToCapital(columnName);
}
